import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  Modal as SemanticModal,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Header, Text as TextLayout } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)``;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 15px 40px;
`;

export const Title = styled(Header)`
  margin-top: 15px !important;
  margin-bottom: 30px !important;
`;

export const TextContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export const Text = styled(Header)``;

export const TextPrimaryBold = styled(TextLayout.Bold)`
  margin-bottom: 10px;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0px;
`;

export const Footer = styled.div`
  display: flex;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export const Button = styled(ButtonLayoutComponent)``;

export const DisqualifiedContainer = styled.div`
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const QuestionCounter = ({ current, total }) => (
  <TextPrimaryBold>
    {current}
    /
    {total}
  </TextPrimaryBold>
);

QuestionCounter.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export const CloseIcon = styled(SemanticIcon).attrs({
  name: 'close',
  size: 'large',
  color: 'grey',
})`
  position: absolute;
  right: 30px;
  top: 20px;
  cursor: pointer;
`;

export const Error = styled(TextLayout.Error)``;
